import { render, staticRenderFns } from "./TopSalesBar.vue?vue&type=template&id=4c16cf57&"
import script from "./TopSalesBar.vue?vue&type=script&lang=js&"
export * from "./TopSalesBar.vue?vue&type=script&lang=js&"
import style0 from "./TopSalesBar.vue?vue&type=style&index=0&id=4c16cf57&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports